import { render, staticRenderFns } from "./DashboardDownloadsCard.vue?vue&type=template&id=b0266a58"
import script from "./DashboardDownloadsCard.vue?vue&type=script&lang=js"
export * from "./DashboardDownloadsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports